import type { StateCreator } from 'zustand'

import type { ActivityFeed } from '../activityfeed.type'

import type { ActivityfeedActionsSlice, ActivityfeedFetchPatch, ActivityfeedStore } from './activityfeed.type'

type ActivityfeedSet = Parameters<StateCreator<ActivityfeedStore, [['zustand/immer', never]], [], ActivityfeedStore>>[0]

export const createActivityfeedSyncActions = (set: ActivityfeedSet): ActivityfeedActionsSlice => ({
  setState: (patch: ActivityfeedFetchPatch) => set((state) => ({ ...state, ...patch })),
  setActivities: (activities: ActivityFeed[]) =>
    set((state) => {
      state.activities = activities
    }),
  setLoading: (loading: boolean) =>
    set((state) => {
      state.loading = loading
    }),
  setError: (error: string | null) =>
    set((state) => {
      state.error = error
    }),
  setLastFetchedProjectId: (projectId: string | null) =>
    set((state) => {
      state.lastFetchedProjectId = projectId
    }),
})
